const INITIAL_STATE = {
    loading: false,    
    cats: [],
    error: false,    
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case 'CAT_CARREGANDO':            
            return { ...state, loading: true, mensagem: '', error: false }

        case 'CAT_CARREGADO':            
            return { ...state, loading: false, cats: action.payload }

        case 'CAT_CARREGADO_ERRO':            
            return { ...state, loading: false, cats: null, mensagem: 'erro', error: action.payload || true }

        case 'CAT_IMPRESSAO_SOLICITADA':            
            return { ...state, loading: true }

        case 'CAT_IMPRESSAO_ERRO':
            return { ...state, loading: false, mensagem: 'erro', error: action.payload || true };

        case 'CAT_PDF_RECEBIDO':
            return { ...state, loading: false, mensagem: 'sucesso', error: false };

        case 'CAT_LIMPAR_MENSAGEM'    :
            return { ...state, loading: false, error: false, mensagem: '' };

        default:
            return state;
    }
}
